import React, { useState } from "react";
import { columnsConfig } from "./reportColumns";
import ReportTable from "./subComponents/reportTable";
import ReportFilters from "./subComponents/reportFilter";

const DailySalesReport: React.FC = () => {
  const [filterInputs, setFilterInputs] = useState({
    fromDate: "",
    toDate: ""
  });

  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: ""
  });

  const handleApplyFilters = () => {
    setFilters(filterInputs);
  };

  const handleResetFilters = () => {
    const empty = { fromDate: "", toDate: "" };
    setFilterInputs(empty);
    setFilters(empty);
  };

  return (
    <div>
      <ReportFilters
        filters={filterInputs}
        setFilters={setFilterInputs}
        onApply={handleApplyFilters}
        onReset={handleResetFilters}
      />
      <ReportTable
        title="Daily Sales Summary"
        endpoint="Vyapar/SaleInvoice/daily-sales-summary"
        columns={columnsConfig.dailySalesReport}
        filters={filters}
      />
    </div>
  );
};

export default DailySalesReport;